export default __webpack_public_path__ + "static/media/testPaperIcon.d93ff3fd.svg";